// @flow
import * as React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import { useFeature } from '../hooks/use-feature';
import ANALYTICS from '../analytics';

import Form from './form';
import cs from './style.pcss';
import OpenWriteForm from './openWriteForm.svg';
import CollapseForm from './collapseForm.svg';

const iconClasses = {
  enter: cs.iconEnter,
  enterActive: cs.iconEnterActive,
  exit: cs.iconExit,
  exitActive: cs.iconExitActive,
};

export default function Feedback(): React.Node {
  const openedParam = useFeature('feedback');
  const [opened, setOpened] = React.useState(false);

  React.useEffect(() => {
    if (openedParam) {
      setOpened(true);
    }
  }, [openedParam]);

  const handleClick = () => {
    setOpened((prev) => {
      ANALYTICS.feedbackShow(!prev);
      return !prev;
    });
  };

  const handleClose = () => {
    ANALYTICS.feedbackShow(false);
    setOpened(false);
  };

  return (
    <>
      <button type="button" className={cs.feedbackButton} onClick={handleClick}>
        <TransitionGroup component={null}>
          {opened && (
            <CSSTransition timeout={400} classNames={iconClasses}>
              <CollapseForm className={cs.icon} />
            </CSSTransition>
          )}
          {!opened && (
            <CSSTransition timeout={400} classNames={iconClasses}>
              <OpenWriteForm className={cs.icon} />
            </CSSTransition>
          )}
        </TransitionGroup>
      </button>
      <CSSTransition
        mountOnEnter
        unmountOnExit
        appear
        timeout={400}
        classNames={{
          enter: cs.enter,
          enterActive: cs.enterActive,
          exit: cs.exit,
          exitActive: cs.exitActive,
        }}
        in={opened}
      >
        <Form onClose={handleClose} />
      </CSSTransition>
    </>
  );
}
